import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */

class GetReservationByIdTransactionsUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new GetReservationByIdTransactionsUseCase({repository: HTTPTransactionRepository.create({config})})
  }

  @tracer({metric: 'GetReservationByIdTransactionsUseCase#execute'})
  @AsyncInlineError()
  async execute({reservationId}) {
    const requestVO = StringSharedValueObject.create({value: reservationId})

    const [error, response] = await this.#repository.getReservationById({reservationIdVO: requestVO})

    if (error) throw error

    return response
  }
}

export const factory = GetReservationByIdTransactionsUseCase.create
